import { Box, makeStyles } from "@material-ui/core";
import * as React from "react";

import { FormRow } from "@/components/selection/FormRow";
import { textStyles } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles({
  row: {
    "& button": { lineHeight: 1.5, [theme.breakpoints.up("md")]: textStyles["PC/Body/Large"] },
    "& button > span:last-child": { maxWidth: "55%" },
  },
});

export const SettingsFormRow: React.FC<React.ComponentProps<typeof FormRow>> = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.row}>
      <FormRow {...props} />
    </Box>
  );
};
